import { HttpInterceptorFn } from '@angular/common/http';
import { environment } from '../../environments/environment';

export const tenantInterceptor: HttpInterceptorFn = (req, next) => {
  const tenantId = localStorage.getItem('tenantId');

  // Paths where tenantId should NOT be added
  const excludeTenantIDPaths = ['client-list'];

  if (req.url.includes(environment.apiUrl)) {
    const apiUrl = environment.apiUrl.endsWith('/')
      ? environment.apiUrl.slice(0, -1)
      : environment.apiUrl;

    const pathAfterApiUrl = req.url.substring(apiUrl.length);

    // Check if the current URL matches an excluded path
    const isExcluded = excludeTenantIDPaths.some((path) =>
      pathAfterApiUrl.includes(path)
    );

    // Build the new URL
    const newUrl =
      isExcluded || !tenantId
        ? `${apiUrl}${pathAfterApiUrl}` // No tenantId
        : `${apiUrl}/${tenantId}/api${pathAfterApiUrl}`; // With tenantId

    const clonedRequest = req.clone({ url: newUrl });
    return next(clonedRequest);
  }

  return next(req);
};
